<template>
  <div class="focused-panel">
    <div class="d-flex no-go-toolbar">
      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create nogo polygon" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select nogo polygon" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>

      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit nogo polygon attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>
      
      <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit nogo polygon geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete nogo polygon" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>

      <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers"
             variant="primary">
        <icon scale=".6" name="link"/>
      </b-btn>

    </div>
    <b-modal v-model="showForm" no-close-on-backdrop no-close-on-esc>
      <div slot="modal-header">
        <label>{{formTitle}}</label>
      </div>
      <div class="p-2">
        <b-form>
          <b-form-group label="Ident:" label-for="no-go-user-defined-ident">
            <b-form-input id="no-go-user-defined-ident" v-model="wellAttrs['ident']" placeholder="Enter No Go ident"></b-form-input>
          </b-form-group>
          <b-form-group label="Description:" label-for="no-go-user-defined-description">
            <b-form-input id="no-go-user-defined-description" v-model="wellAttrs['description']" placeholder="Enter No Go description"></b-form-input>
          </b-form-group>
        </b-form>
      </div>
      <div slot="modal-footer" class="designatron-modal-footer">
        <b-row>
          <b-col>
            <div role="group" class="btn-group">
              <b-btn size="sm" class="float-right" variant="primary" @click="close">
                Close
              </b-btn>
              <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
                Save
              </b-btn>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>

<script>


  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
  import Draw from 'ol/interaction/Draw'
  import Snap from 'ol/interaction/Snap'
  import bezierCurve from '@turf/bezier-spline'
  import GeoJSON from 'ol/format/GeoJSON'
  import { LineString } from 'ol/geom'

  export default {
    name: 'no-go-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        multiEdit: false,
        mergeEnabled: false,
        geomType: 'Polygon',
        geometryName: 'geo',
        wellLayerName: 'v4:no_go_user_defined',
        wellAttrs: {
          ident: '',
          comments: '',
          library_id: null,
          asset_tag: '',
          description: ''
        },
        schema: 'no_go_user_defined',
        identState: null,
        initialIdent: null,
        hoverLock: false,
        lockable: true
      }
    },
    methods: {
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/NoGoEditor.vue